import { EXCLUSION_LABEL } from '../../constants/exclusions.js';

// Grouped exclusion reason dropdown — used on the Excluded tab.
export function ExclusionReasonSelect({ value, onChange, counts = {} }) {
  const c = (k) => counts[k]?.toLocaleString() || 0;
  const opt = (k) => <option value={k}>{EXCLUSION_LABEL[k] || k} ({c(k)})</option>;
  return (
    <div className="form-group" style={{ margin: 0 }}>
      <label style={{ fontSize: 11 }}>Exclusion Reason</label>
      <select value={value} onChange={(e) => onChange(e.target.value)} style={{ width: 300 }}>
        <option value="">All reasons</option>
        <optgroup label="PSC Rules">
          {opt('site_excluded')}
          {opt('labor_metric_excluded')}
          {opt('cost_center_excluded')}
        </optgroup>
        {/* "Inactive in NetSuite" reasons were reclassified to the Gaps tab
            on 2026-06-08 — they are mapping gaps now, not exclusions. */}
        <optgroup label="Non-Billable Payroll">
          {opt('non_billable_payroll')}
          {opt('no_billable_content')}
        </optgroup>
        {/* Dayforce-side data holes so severe there's nothing to map. */}
        <optgroup label="Incomplete Timesheet">
          {opt('no_dayforce_context')}
        </optgroup>
        {/* Ops decision rather than an engine rule — its own group so it's
            obvious these were excluded by a person, and so ops can filter
            straight to the set they can undo. */}
        <optgroup label="Manual">
          {opt('manually_excluded')}
        </optgroup>
      </select>
    </div>
  );
}
